import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin: auto;
  width: 100%;
  padding: 30px 40px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 4px;

  @media (max-width: 500px) {
    height: 100%;
  }
`;
